import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { DialogCloseButton } from 'components/common/DialogCloseButton';
import { ShareEvent, ShareEventProps } from 'components/event/ShareEvent';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface ShareEventDialogProps extends ShareEventProps {
  open: boolean;
  onClose?: (ev: React.MouseEvent) => void;
}

export function ShareEventDialog({ open, onClose, ...rest }: ShareEventDialogProps) {
  const { t } = useTranslation();

  const handleCloseDialog = (ev: React.MouseEvent) => {
    onClose?.(ev);
  };

  return (
    <Dialog open={open} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
      <DialogTitle variant="h2" sx={{ textAlign: 'center' }}>
        {t('share', 'Share')}
      </DialogTitle>
      <DialogCloseButton onClose={handleCloseDialog} />
      <DialogContent>
        <ShareEvent {...rest} />
      </DialogContent>
    </Dialog>
  );
}
